/*
  Harmélys — Offres « plusieurs fois la même culotte ».
  Le choix (1, 2 ou 3 culottes) règle la quantité du vrai sélecteur du thème, caché, et affiche le total
  dans le bouton « Ajouter au panier ». Le thème recharge ces blocs quand on change de taille :
  on mémorise le choix et on le réapplique.
*/
(() => {
  if (window.hmBundleOffersLoaded) return;
  window.hmBundleOffersLoaded = true;

  // form-id -> quantité choisie
  const chosen = new Map();

  const quantityInputs = (formId) =>
    document.querySelectorAll(`input.quantity-selector__input[name="quantity"][form="${formId}"]`);

  const submitButtons = (formId) =>
    document.querySelectorAll(`buy-buttons[form="${formId}"] button[type="submit"]`);

  const apply = (bundle) => {
    const formId = bundle.getAttribute('data-form-id');
    const qty = chosen.get(formId) || '1';
    const radio = bundle.querySelector(`.hm-bundle__radio[value="${qty}"]`) || bundle.querySelector('.hm-bundle__radio');

    if (radio && !radio.checked) radio.checked = true;

    quantityInputs(formId).forEach((input) => {
      // On cache uniquement le sélecteur du thème (pas le bloc, qui contient aussi les offres)
      const wrapper = input.closest('quantity-selector')?.parentElement;
      wrapper?.setAttribute('data-hm-bundle-hidden-qty', '');

      if (input.value !== radio.value) {
        input.value = radio.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    submitButtons(formId).forEach((button) => {
      if (button.disabled) {
        button.removeAttribute('data-hm-bundle-price');
      } else if (button.getAttribute('data-hm-bundle-price') !== radio.dataset.price) {
        button.setAttribute('data-hm-bundle-price', radio.dataset.price);
      }
    });
  };

  const applyAll = () => document.querySelectorAll('[data-hm-bundle]').forEach(apply);

  document.addEventListener('change', (event) => {
    const radio = event.target.closest?.('.hm-bundle__radio');
    if (!radio) return;

    const bundle = radio.closest('[data-hm-bundle]');
    chosen.set(bundle.getAttribute('data-form-id'), radio.value);
    apply(bundle);
  });

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; applyAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  applyAll();
})();
